// axios-api.ts
import axios, { type AxiosInstance, type AxiosError, type AxiosRequestConfig } from 'axios'
import store from '@/store/index.js'
import router from '@/router'

// Environment configuration
const API_CONFIG = {
  production: 'https://api.alignd.co.za',
  staging: 'https://api.staging.alignd.co.za',
  development: process.env.VUE_APP_BASE_URL || 'http://localhost:8000',
} as const

// Get base URL based on hostname
const getBaseURL = (): string => {
  
  const hostname = window.location.hostname;
  
  console.log("Hostname: ", hostname);
  
  if (hostname === 'cms.alignd.co.za') {
    return API_CONFIG.production;
  }
  
  if (hostname === 'cms.staging.alignd.co.za') {
    return API_CONFIG.staging;
  }
  
  return API_CONFIG.development;
}

// Create axios instance
export const api: AxiosInstance = axios.create({
  baseURL: getBaseURL(),
  // NB: Temporarly: Increased to 600000ms (10 minutes)
  timeout: 600000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor - Add auth token
api.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const isLoggedIn = store.getters['login/isLoggedIn'];
    const isLoginRequest = config.url?.includes('login');
    
    if (isLoggedIn && !isLoginRequest) {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Token ${token}`;
      }
    }
     // Add auth token if available
    const token = localStorage.getItem('token');

    console.log("Token in axios-api: ", token);

    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }
    // Add API key to all requests
    // const apiKey = process.env.VUE_APP_API_KEY;
    // if (apiKey) {
    //   config.headers.Authorization = `API-KEY  ${apiKey}`;
    // }

    console.log("Config in axios-api: ", config);
    
    return config
  },
  (error: AxiosError) => Promise.reject(error)
)

// Response interceptor - Handle errors
api.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {

    const status = error.response?.status
    
    switch (status) {
      case 401:
        // Unauthorized - logout and redirect
        await store.dispatch('login/logoutUser')
        await store.dispatch('login/authError')
        router.push('/login')
        console.error('Unauthorized access - please log in again.', error.message)
        break
        
      case 403:
        // Forbidden
        console.error('Access forbidden:', error.message);
        break
        
      case 404:
        // Not found
        console.error('Resource not found:', error.message);
        break
        
      case 500:
        // Server error
        console.error('Server error:', error.message);
        break
        
      default:
        console.error('Request failed:', error.message);
    }
    
    return Promise.reject(error)
  }
);
